(function () {
    'use strict';

    angular.module("imApp").factory("trMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getPickSelectSettings: function (parms) {
                return $ihttp.post({
                    method: 875,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
